import { render, staticRenderFns } from "./epidemic_training_public_teachers.vue?vue&type=template&id=706a0acc&scoped=true"
import script from "./epidemic_training_public_teachers.vue?vue&type=script&lang=js"
export * from "./epidemic_training_public_teachers.vue?vue&type=script&lang=js"
import style0 from "./epidemic_training_public_teachers.vue?vue&type=style&index=0&id=706a0acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a0acc",
  null
  
)

export default component.exports